import { defineMessages } from 'react-intl';

const translations = {
  pagination: {
    currentPageLabel: {
      id: 'dataList.pagination.currentPageLabel',
      defaultMessage: 'page {page}',
      description: 'Data list current page label',
    },
    previousPageLabel: {
      id: 'dataList.pagination.previousPageLabel',
      defaultMessage: 'Previous page',
      description: 'Data list previous page label',
    },
    nextPageLabel: {
      id: 'dataList.pagination.nextPageLabel',
      defaultMessage: 'Next page',
      description: 'Data list next page label',
    },
  },
  selection: {
    all: {
      id: 'dataList.selection.all',
      defaultMessage: 'All',
      description: 'Data list selection all label',
    },
    actions: {
      selectAll: {
        id: 'dataList.selection.actions.selectAll',
        defaultMessage: 'Select all',
        description: 'Data list selection action select all label',
      },
      selectPage: {
        id: 'dataList.selection.actions.selectPage',
        defaultMessage: 'Select page',
        description: 'Data list selection action select page label',
      },
      deselectAll: {
        id: 'dataList.selection.actions.deselectAll',
        defaultMessage: 'Deselect all',
        description: 'Data list selection action deselect all label',
      },
    },
  },
};

export default defineMessages(translations);
